import * as React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import './CloseHomeButton.scss';

export interface CloseProjectsButtonProps {
}

export default class CloseProjectsButton extends React.Component<CloseProjectsButtonProps> {
  public render() {
    return (
      <div className="close-home-button-partial">
        <Link to="/profile/projects" className="close-btn">
          <FontAwesomeIcon icon={faTimes} />
        </Link>
      </div>
    );
  }
}
